import React, { useEffect, useRef, useState } from "react";
import userIcon from "../../../images/img/user.svg";
import deliveryIcon from "../../../images/img/deliverytime-icon2.svg";
import agentIcon from "../../../images/img/generic-human.svg";
import { Constants } from "../../../Constants/Constants";
import useDetectKeyboardOpen from "use-detect-keyboard-open";
export default function AgentConversation(props) {
  const { messages, typingIndicator, refresh, chatRefID } = props;
  const [firstMessageRecieved, setFirstMessageRecieved] = useState(false);
  const isKeyboardOpen = useDetectKeyboardOpen();
  const scrollREf = useRef();

  // const {messages,scrollTrigger} = props;
  const returnMessageStyle = (type) => {
    switch (type) {
      case "Client":
        return "customer-agent-message";
        break;
      case "Agent":
        return "agent-agent-message";
        break;
      case "INFO":
        return "info-agent-message";
        break;
      case "External":
        return "info-agent-message";
        break;

      default:
        break;
    }
  };
  const scrollToBottom = () => {
    scrollREf && scrollREf.current && scrollREf.current.scrollIntoView();
  };

  const textAreaPos = document
    .getElementById("agent-button")
    ?.getBoundingClientRect();
  const textAreaY = textAreaPos?.height || 0;
  const textAreax = textAreaPos?.width || 0;
  useEffect(() => {
    if (textAreaPos !== undefined) {
      scrollToBottom();
    }
  }, [textAreaY, textAreax]);
  useEffect(() => {
    visualViewport.addEventListener("resize", (e) => {
      const h = e.target.height;
    });
  }, []);
  const { tempMessages, scrollTrigger } = props;
  useEffect(() => {
    setTimeout(() => {
      scrollToBottom();
    }, 100);
  }, [tempMessages, isKeyboardOpen, scrollTrigger]);

  let newNodeAdded = document.getElementsByClassName(
    "AgentMessagesContainer"
  )[0]?.childNodes.length;

  useEffect(() => {
    setTimeout(() => {
      scrollToBottom();
    }, 100);

    if (newNodeAdded !== undefined && newNodeAdded !== null) {
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    }
  }, [newNodeAdded]);
  useEffect(() => {
    addResizeHandler();
    return () => {
      window.removeEventListener("resize", addResizeHandler);
    };
  }, []);
  const addResizeHandler = () => {
    window.addEventListener("resize", function (event) {
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    });
  };

  const returnMessageComponent = (type, textMessage, data, position, time) => {
    switch (type) {
      case "Client":
        {
          setTimeout(() => {
            scrollToBottom();
          }, 100);
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "fit-content",
                minHeight: 3 + "rem",
                height: "auto",
                flexDirection: "row-reverse",
              }}
            >
              <div
                style={{
                  width: "10px",
                  height: "10px",
                  border: "1px solid grey",
                  borderRadius: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: "1%",
                  background: "#E940AD",
                  color: "white",
                  fontWeight: 400,
                  padding: "1em",
                  textTransform: "capitalize",
                }}
              >
                {JSON.parse(localStorage.getItem("userName")) !== "Testing" ? (
                  localStorage
                    .getItem("userName")
                    .toString()
                    ?.match(/\b(\w)/g)
                    .join("")
                ) : (
                  <img height="15" width="15" src={userIcon}></img>
                )}
              </div>
              <div style={{ width: "100%", textAlign: "-webkit-right" }}>
                <div
                  className={"packs-text"}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "right",
                    width: "max-content",
                    maxWidth: "80vw",
                  }}
                >
                  <p>{textMessage}</p>
                </div>
                <div className="agent-customer-text-timeAndSeen">
                  <small>{time}</small>
                  {data.seen ? null : <img height="" src={deliveryIcon}></img>}
                </div>
              </div>
            </div>
          );
        }
        break;
      case "Agent":
        {
          setTimeout(() => {
            scrollToBottom();
          }, 100);
          return chatRefID === textMessage ? null : (
            <>
              <div className="Agent-message-container" id="agccn360">
                <div className="Agent-message-image">
                  <img src={agentIcon}></img>
                </div>
                <div
                  className={"chat-text"}
                  style={{
                    width: "80%",
                    display: "flex",
                    flexDirection: "column",
                    boxShadow: "0px 4px 5px -2px rgba(0,0,0,0.3)",
                  }}
                >
                  {position > 0 ? (
                    <p> {textMessage}</p>
                  ) : (
                    <div>
                      <p>
                        {" "}
                        Welcome to Tata Play{" "}
                        <p
                          style={{
                            textTransform: "capitalize",
                            // color: "#e940ad",
                          }}
                        >
                          {props.customerData.nickname}
                        </p>{" "}
                        ,
                      </p>{" "}
                      <br />
                      <p> We are here to help you ,</p>
                      <p>
                        Please type in your query in the chat box and click on
                        the send button.
                      </p>
                      <br />
                      <p>
                        Please note that this chat may be recorded and used for
                        quality assurance and training purpose.
                      </p>
                    </div>
                  )}
                  {/* {<p> { textMessage}</p>} */}
                </div>
              </div>

              <div className="agent-agent-text-timeAndSeen">
                <small>{time}</small>
              </div>
            </>
          );
        }

        break;
      case "External":
        {
          setTimeout(() => {
            scrollToBottom();
          }, 100);
          return chatRefID === textMessage ? null : (
            <div className="info-message-container">
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#000",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    width: "82%",
                    background: "#e940ad0f",
                    borderRadius: "10px",
                    padding: "3%",
                    color: "#000",
                    textAlign: "left",
                  }}
                >
                  <p>{textMessage}</p>
                </div>
              </div>
              <div className="info-text-timeAndSeen">
                <small>{time}</small>
              </div>
            </div>
          );
        }

        break;
      // case "typingStarted":
      // return (
      //   <div
      //     style={{
      //       display: "flex",
      //       justifyContent: "center",
      //       width: "100%",
      //       alignItems: "center",
      //       minHeight: "3rem",
      //       height: "auto",
      //       fontSize: "smaller",
      //       color: "grey",
      //     }}
      //   >
      //     <p>{textMessage}</p>
      //   </div>
      // );
      // break;
      default:
        break;
    }
  };
  const returnChild = () => {
    //based on type it should
    // if type -- agent
    // <div>
    //<img></img
    //</div>
    // if type -- customer
    // <div>
    //</div>
  };

  return (
    <div className="agent-conversation-container center-align">
      {props.messages.length === 0 ? (
        "No Messages yet"
      ) : (
        <div className="AgentMessagesContainer center-align ">
          {messages.map((oneMessage, index) => (
            <div className={returnMessageStyle(oneMessage.from.type)}>
              {returnMessageComponent(
                oneMessage.from.type,
                oneMessage.text,
                oneMessage,
                index,
                oneMessage.time
              )}
            </div>
          ))}
        </div>
      )}
      <div
        ref={scrollREf}
        style={{
          width: "100%",
          height: "1rem",

          position: "relative",
        }}
      ></div>
      {/* {isTyping && (
        <div className="agentTypingIndicatorSection" key={props}>
          <strong>Agent typing...</strong>
        </div>
      )} */}
    </div>
  );
}
